import styled from "styled-components";

export const CardWrapper = styled.div<{ clickable: boolean }>`
  position: relative;
  width: 309.5px;
  height: 124px;
  background-color: #FFFFFF;
  border-radius: 8px;
  box-shadow: 0px 4px 6px 0px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  flex-shrink: 0;
  cursor: ${({ clickable }) => (clickable ? 'pointer' : 'default')};
  transition: transform 0.15s ease, box-shadow 0.15s ease;

  &:hover {
    ${({ clickable }) =>
      clickable
        ? `
          transform: translateY(-2px);
          box-shadow: 0px 6px 10px 0px rgba(0, 0, 0, 0.12);
        `
        : ''}
  }
`;

export const AccentBar = styled.span<{ color: string }>`
  position: absolute;
  top: -5.39px;
  bottom: -5.39px;
  left: 0;
  width: 6px;
  background-color: ${({ color }) => color};
`;

export const Content = styled.div`
  position: absolute;
  top: 34px;
  left: 22px;
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const IconWrapper = styled.div`
  width: 56px;
  height: 56px;
  flex-shrink: 0;

  img {
    width: 100%;
    height: 100%;
    display: block;
  }
`;

export const CardTitle = styled.p`
  width: 126px;
  margin: 0;
  font-family: 'Lato', sans-serif;
  font-weight: 700;
  font-size: 24px;
  line-height: 28px;
  color: #364863;
  text-transform: uppercase;
`;
